import { useEntropyBrowser } from '#pplx/frontend/apps/ask/comet-browser/providers/EntropyBrowserHooks.js';
import { useClickDownloadComet } from '#pplx/frontend/apps/ask/comet-download/hooks/useClickDownloadComet.js';
import { isMaybeIncognitoComet } from '#pplx/frontend/apps/ask/comet-shared/cometUtils.js';
import { useWebPlatform } from '#pplx/frontend/platform-components/useWebPlatform.js';
import { useMemo } from 'react';
export const useUpsellActionCometRuntime = () => {
    const cometAdapter = useEntropyBrowser();
    const isCometBrowser = isMaybeIncognitoComet();
    const { device: { isWindowsOS, isMacOS }, } = useWebPlatform();
    const { handleDownloadClick: handleCometDownloadClick } = useClickDownloadComet({
        isWindows: isWindowsOS,
        isUnsupportedDevice: !isMacOS && !isWindowsOS,
    });
    const cometSurface = import.meta.env.VITE_IS_SIDECAR_BUILD || import.meta.env.VITE_IS_EMBEDDED_SIDECAR_BUILD
        ? 'sidecar_thread'
        : isCometBrowser
            ? 'search_results_page'
            : undefined;
    return useMemo(() => ({
        cometAdapter,
        cometSurface,
        handleCometDownloadClick,
    }), [cometAdapter, cometSurface, handleCometDownloadClick]);
};
//# sourceMappingURL=useUpsellActionCometRuntime.js.map